import 'global.css';
import { Routes, Route } from "react-router-dom";
import { MainLayout } from 'components/shared';
import { ProtectedRoute } from 'auth/ProtectedRoute';
import Brands from 'pages/Brands';
import ReferralFee from "pages/CalculatorLibrary/ReferralFee";
import ReferralFeeItem from "pages/CalculatorLibrary/ReferralFee/Item";
import SizeTiersShippingWeight from "pages/CalculatorLibrary/SizeTiersShippingWeight";
import SizeTiersShippingWeightItem from "pages/CalculatorLibrary/FullfillmentFee";
import MonthlyLongTermStorageFee from "pages/CalculatorLibrary/MonthlyLongTermStorageFee";
import EstimateSales from 'pages/EstimateSales';
import KeepaKeys from 'pages/KeepaKeys';
import EstimateSalesCategory from "pages/EstimateSales/Category";
import Tools from 'pages/Tools';
import UserManagement from 'pages/UserManagement';
import UserOverview from 'pages/UserManagement/UserOverview';
import Versions from 'pages/Versions';
import FullfillmentFee from 'pages/CalculatorLibrary/FullfillmentFee';
import PageNotFound from 'pages/404';
import Meltable from 'pages/Meltable';
import SPTokenPool from 'pages/SPTokenPool';
import Logs from 'pages/Logs';
import Login from 'pages/Login';
import Callback from 'pages/Callback';
import ProductListURLs from './pages/AZArbitrageManagerment/ProductListURLs';
import ProductSelectors from './pages/AZArbitrageManagerment/ProductSelectors';

const App = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/callback" element={<Callback />} />
      <Route path="/" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
        <Route path="/brands" element={<Brands />} />
        <Route path="/calculator-library-unit-test/:platform/referral-fee">
          <Route path="/calculator-library-unit-test/:platform/referral-fee/:marketplace" element={<ReferralFee />} />
          <Route path="/calculator-library-unit-test/:platform/referral-fee/:marketplace/:categoryId" element={<ReferralFeeItem />} />
        </Route>
        <Route path="/calculator-library-unit-test/:platform/fullfillment-fee">
          <Route path="/calculator-library-unit-test/:platform/fullfillment-fee/:marketplace" element={<FullfillmentFee />} />
        </Route>
        <Route path="/calculator-library-unit-test/:platform/size-tiers-shipping-weight">
          <Route path="/calculator-library-unit-test/:platform/size-tiers-shipping-weight/:marketplace" element={<SizeTiersShippingWeight />} />
          <Route path="/calculator-library-unit-test/:platform/size-tiers-shipping-weight/:marketplace/:id" element={<SizeTiersShippingWeightItem />} />
        </Route>
        <Route path="/calculator-library-unit-test/:platform/monthly-long-term-storage-fee">
          <Route path="/calculator-library-unit-test/:platform/monthly-long-term-storage-fee/:marketplace" element={<MonthlyLongTermStorageFee />} />
        </Route>
        <Route path="/estimate-sales">
          <Route path="/estimate-sales/:location" element={<EstimateSales />} />
          <Route path="/estimate-sales/:location/:version" element={<EstimateSales />} />
          <Route path="/estimate-sales/:location/:version/:category" element={<EstimateSalesCategory />} />
        </Route>
        <Route path="/keepa-keys" element={<KeepaKeys />} />
        <Route path="/setting" element={<EstimateSales />} />
        <Route path="/tools" element={<Tools />} />
        <Route path="/user-management" element={<UserManagement />} />
        <Route path="/user/:email" element={<UserOverview />} />
        <Route path="/versions" element={<Versions />} />
        <Route path="/meltable" element={<Meltable />} />
        <Route path="/sp-token-pool" element={<SPTokenPool />} />
        <Route path="/logs">
          <Route path="/logs/rate-limit-logs" element={<Logs />} />
          <Route path="/logs/request-logs" element={<Logs />} />
        </Route>
        <Route path="/azarbitrage">
          <Route path="/azarbitrage/manage-product-list-urls/:marketplace" element={<ProductListURLs />} />
          <Route path="/azarbitrage/manage-product-selectors/:marketplace" element={<ProductSelectors />} />
          {/* <Route path="/azarbitrage/manage-category-urls">
            <Route path="/azarbitrage/manage-category-urls/:marketplace/:domain" element={<CategoryUrlList />} />
          </Route> */}
        </Route>
      </Route>
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
}

export default App;
